import catalonia from './catalonia';

const forms = {
  [catalonia.chainSlug]: catalonia.forms,
};

const components = {};

export default {
  customForms: chainSlug => {
    if (forms[chainSlug]) {
      return forms[chainSlug];
    }
    return [];
  },
  customComponents: ({ chainSlug, component, props }) => {
    if (components[chainSlug] && components[chainSlug][component]) {
      const Component = components[chainSlug][component];
      return <Component {...props} />;
    }
    return null;
  },
};
